<template>
  <div class="row">
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
        </loading>
    <div class="col-md-12">
      <!-- <iframe src="http://localhost:8081" /> -->
      <div class="page-title-box">
        <div class="float-right">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);">Setting</a>
            </li>
            <li class="breadcrumb-item">
              <a href="javascript:void(0);">Message</a>
            </li>
            <li class="breadcrumb-item active">Template</li>
          </ol>
        </div>
        <h4 class="page-title">Message Template</h4>
      </div>
      <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-inline">
                <div class="button-group">
                  <button type="button" class="btn btn-outline-primary btn-sm" data-toggle="tooltip" data-placement="top" title="Create New Employee" @click="addRole">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                  <button type="button" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="top" title="Refresh" @click="refreshList">
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="form-group mx-sm-3 mb-2">
                    <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                </div>
                <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                <nav aria-label="Page navigation example" class="pull-right">
                    <ul class="pagination">
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                <i class="fa fa-angle-left" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </nav>
              </div>
            </div>
            <div class="row">
                <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm">
                        <thead>
                            <tr>
                                <th>
                                <label class="form-checkbox">
                                    <input type="checkbox" v-model="selectAll">
                                    <i class="form-icon"></i>
                                </label>
                                </th>
                                <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-if="filterData.length < 1">
                            <td colspan="9" style="text-align: center;"><i>No Data</i></td>
                        </tr>
                        <tr v-for="d in filterData" :key="d.id" @click="editData(d.id)" style="cursor: pointer">
                            <td>
                            <label class="form-checkbox">
                                <input type="checkbox" :value="d.id" v-model="selected">
                                <i class="form-icon"></i>
                                </label>
                            </td>
                            <td>{{ d.template_id }}</td>
                            <td>{{ d.message }}</td>
                            <td>{{ d.url }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { messageTemplateUrl, getHeader } from '../../config'

export default {
  name: 'MessageTemplateList',
  props: ['scroll'],
  components: {
    Loading
  },
  data () {
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 25,
      currentPage: 1,
      title: [{
        name: 'ID',
        prop: 'template_id'
      }, {
        name: 'Message',
        prop: 'message'
      }, {
        name: 'URL',
        prop: 'url'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  methods: {
    editData: function (id) {
      this.data = this.dataRaw.find(data => data.id === id)
      this.$emit('editMessage', this.data)
    },
    addRole () {
      this.$emit('newMessage')
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      axios.get(messageTemplateUrl, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            'Cannot Get Message Template',
            'error'
          )
        })
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  },
  computed: {
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  }
}
</script>
